import {ValueDefinition} from '@/model/types';

export const enum Country {
  CANADA = 'DV-47#0',
  OTHER = 'DV-47#1',
}

export const DV_47 = {
  id: 'DV-47',
  description: {
    fr: 'Pays',
    en: 'Country',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Canada',
        en: 'Canada',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Autre',
        en: 'Other',
      },
    },
  ],
} as const satisfies ValueDefinition;
